import React from 'react'
import PropTypes from 'prop-types'

const EstimateIcon = ({ disabled = false }) => {
    const disabledColor = '#C1C9D7'
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
        >
            <g clipPath="url(#clip0)">
                <path
                    d="M30.9208 39.2448H9.20647C8.82606 39.2448 8.33118 39.2448 7.80101 39.2448C6.14416 39.2448 4.82017 37.9018 4.84925 36.2452C4.85758 35.7708 4.86361 35.3288 4.86361 34.9782V5.1115C4.86361 4.75009 4.86357 4.31266 4.86353 3.84363C4.86336 2.18731 6.20599 0.844699 7.86231 0.844783C8.36627 0.844808 8.83711 0.844833 9.20647 0.844833H23.1794C23.9658 0.844833 24.7208 1.15366 25.2818 1.70482L34.3661 10.6297C34.9402 11.1938 35.2636 11.9649 35.2636 12.7697V34.9782C35.2636 35.3227 35.2636 35.767 35.2636 36.2446C35.2634 37.9015 33.9201 39.2448 32.2633 39.2448C31.7566 39.2448 31.2836 39.2448 30.9208 39.2448Z"
                    fill={disabled ? '#ECEFF3' : 'white'}
                    stroke={disabled ? disabledColor : '#0C0D0E'}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M24.2107 1.0498V9.47086C24.2107 9.50615 24.2107 9.54119 24.2107 9.57612C24.2106 10.6807 25.106 11.5761 26.2105 11.5761C26.2472 11.5761 26.2824 11.5761 26.3159 11.5761H34.737"
                    stroke={disabled ? disabledColor : '#0C0D0E'}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <rect
                    x="10.5264"
                    y="21.0498"
                    width="17.8947"
                    height="1.57895"
                    rx="0.789474"
                    fill={disabled ? disabledColor : '#FFC20D'}
                />
                <rect
                    x="10.5264"
                    y="27.3652"
                    width="17.8947"
                    height="1.57895"
                    rx="0.789474"
                    fill={disabled ? disabledColor : '#FFC20D'}
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.0449219)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

EstimateIcon.propTypes = {
    disabled: PropTypes.bool,
}

export default EstimateIcon
